import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from 'react';
import isEqual from 'react-fast-compare';

import { Select, MenuItem, ListSubheader, TextField, InputAdornment, FormControl } from '@material-ui/core';
// import { multiSelectStrings } from '../../../Functions/utils';
import { multiSelectStrings } from '../../../../../Functions/utils';

import './ModuleValueSelect.css';


export default function ModuleValueSelect({ cond, values, onChangeValue }) {
  const { t } = useTranslation();

  const [selecterOpen, setSelecterOpen] = useState(false);
  const [textValue, setTextValue] = useState(cond && cond.xtra_desc);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (cond.xtra_desc !== textValue) {
      setTextValue(cond.xtra_desc);
    }
  }, [cond, setTextValue]);


  const isAndOr = ['AND', 'OR'].includes(cond.condition);

  return (
    <FormControl disabled={isAndOr}>
      <Select //className="sidebar__select"
        style={{
          display: "flex",
          width: 340,
          height: '34px',
          maxWidth: '100%',
          outline: '0',
          cursor: 'pointer',
          fontSize: '15px',
          fontWeight: '600',
          fontFamily: 'inherit',
          transition: '0.25s',

          // opacity: (loading || (pickers.groups && pickers.groups.length === 0)) ? '0.4' : '1',
          // cursor: (loading || (pickers.groups && pickers.groups.length === 0)) ? 'not-allowed' : 'pointer'
        }}

        id='modulevalue_selecter'
        displayEmpty

        title={isAndOr ? '...' : (textValue ? textValue : t('scenarios.module_data.help_text'))}
        open={selecterOpen}

        onClose={() => {
          setSelecterOpen(false);
          onChangeValue(textValue);
        }}
        onOpen={() => {
          setSelecterOpen(true)
        }}

        labelWidth={0}
        value={values}
        onChange={e => {
        }}

        // VALUE WHEN COMBO CLOSED
        renderValue={value => {

          return (
            <div
              style={{
                width: "100%",
                display: 'flex'
              }}
            >
              <span
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  textAlign: 'left',
                  fontSize: '1rem', fontWeight: '500',
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  transition: '0.25s',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>{textValue ?? ''}
              </span>
            </div>

          )
        }}
      >
        <ListSubheader id="modulevalue_selecter_custom"
          style={{ lineHeight: "12px", paddingLeft: '8px', paddingRight: '8px' }}
        >
          {/* <TextField
            size="small"
            autoFocus
            //placeholder={t('scenarios.module_data.custom_text')}
            placeholder={multiSelectStrings(t, '').search}
            fullWidth
            InputProps={{
              startAdornment: <InputAdornment position="start">
                <span
                  style={{
                    fontSize: '20px',
                  }}
                  className="material-icons-outlined">search</span>
              </InputAdornment>
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          /> */}
          <TextField
            size="small"
            autoFocus
            placeholder={t('scenarios.module_data.custom_text')}
            fullWidth
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>

        {values && values.length > 0 ? (
          values.sort(function (a, b) {
            if (a.toLowerCase() < b.toLowerCase()) {
              return -1;
            }
            if (b.toLowerCase() < a.toLowerCase()) {
              return 1;
            }
            return 0;
          }).map((value, key) => {

            const isDisplayed = (value.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
            return (
              <MenuItem
                value={key}
                name={value}

                style={{
                  paddingLeft: '6px',
                  paddingRight: '20px',
                  lineHeight: '200x',
                  display: (isDisplayed) ? 'flex' : 'none'
                }}

                onClick={(e) => {
                  e.stopPropagation();
                  setTextValue(value);

                  onChangeValue(value);
                }}
              >
                <span
                  style={{
                    padding: '0 4px',
                    width: "84%",
                    maxWidth: "100%",
                    textAlign: 'left',
                    fontSize: '1rem', fontWeight: '500',
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    transition: '0.25s',
                  }}
                >{value}
                </span>
              </MenuItem >
            )
          })
        ) : (
          <div>
          </div>
        )}
      </Select>
    </FormControl>
  );
}
